// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.MessageList_content__Wa2If {
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    overflow-y: scroll;
    padding-left: 10px;
    padding-bottom: 15px;
    padding-right: 70px;
}
.MessageList_mobile_content__EZHn4 {
    padding-right: 20px!important;
    padding-left: 20px!important;
    -webkit-overflow-scrolling : touch;
}
.MessageList_mobile_content__EZHn4 .MessageList_item_box__78XFY {
    width: 100%;
    padding-right: 0;
}
.MessageList_mobile_content__EZHn4 .MessageList_message_times__9MbYy {
    display: none!important;
}
/* 自定义移动端滚动条 */
.MessageList_mobile_content__EZHn4::-webkit-scrollbar {/*滚动条整体样式*/
    -webkit-appearance: none;
    width: 4px!important;
    height: 4px!important;
}

.MessageList_mobile_content__EZHn4::-webkit-scrollbar-thumb {/*滚动条里面小方块*/
    cursor: pointer;
    border-radius: 5px;
    background: #e9e9e9;
    -webkit-transition: color .2s ease;
    transition: color .2s ease;
}

.MessageList_mobile_content__EZHn4::-webkit-scrollbar-thumb:hover {
    background: #e3e3e3;
}
/* 自定义滚动条 */
.MessageList_content__Wa2If::-webkit-scrollbar {/*滚动条整体样式*/
    -webkit-appearance: none;
    width: 10px;
    height: 10px;
}

.MessageList_content__Wa2If::-webkit-scrollbar-thumb {/*滚动条里面小方块*/
    cursor: pointer;
    border-radius: 5px;
    background: #e9e9e9;
    -webkit-transition: color .2s ease;
    transition: color .2s ease;
}

.MessageList_content__Wa2If::-webkit-scrollbar-thumb:hover {
    background: #e3e3e3;
}

.MessageList_item_box__78XFY {
    width: 60%;
    margin: 0 auto;
    padding-right: 50px;
    padding-bottom: 16px;
}

::selection {
    background-color: #cce2ff;
    color: rgba(0,0,0,.87);
}

.MessageList_message_times__9MbYy {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 27px;
    padding-left: 63px;
    margin-top: 32px;
    font-size: 16px;
}

.MessageList_message_times_text__x4xXD {
    display: inline-block;
    width: auto;
    height: 100%;
    padding: 0 5px;
    border-radius: 6px;
    color: #fff;
    background-color: #cbd1d8;
    line-height: 27px;
}

.MessageList_message_times_today_text__jzLqK {
    width: 100%;
    height: 27px;
    margin: 0 !important;
}
`, "",{"version":3,"sources":["webpack://./src/pages/home/components/MessageList/index.module.css"],"names":[],"mappings":";AACA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;AACvB;AACA;IACI,6BAA6B;IAC7B,4BAA4B;IAC5B,kCAAkC;AACtC;AACA;IACI,WAAW;IACX,gBAAgB;AACpB;AACA;IACI,uBAAuB;AAC3B;AACA,cAAc;AACd,uDAAoC,UAAU;IAC1C,wBAAwB;IACxB,oBAAoB;IACpB,qBAAqB;AACzB;;AAEA,6DAA0C,WAAW;IACjD,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IAEnB,kCAA0B;IAA1B,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;AACvB;AACA,WAAW;AACX,gDAA6B,UAAU;IACnC,wBAAwB;IACxB,WAAW;IACX,YAAY;AAChB;;AAEA,sDAAmC,WAAW;IAC1C,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IAEnB,kCAA0B;IAA1B,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,cAAc;IACd,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,oBAAoB;AACxB","sourcesContent":["\n.content {\n    width: 100%;\n    height: 100%;\n    overflow-x: hidden;\n    overflow-y: scroll;\n    padding-left: 10px;\n    padding-bottom: 15px;\n    padding-right: 70px;\n}\n.mobile_content {\n    padding-right: 20px!important;\n    padding-left: 20px!important;\n    -webkit-overflow-scrolling : touch;\n}\n.mobile_content .item_box {\n    width: 100%;\n    padding-right: 0;\n}\n.mobile_content .message_times {\n    display: none!important;\n}\n/* 自定义移动端滚动条 */\n.mobile_content::-webkit-scrollbar {/*滚动条整体样式*/\n    -webkit-appearance: none;\n    width: 4px!important;\n    height: 4px!important;\n}\n\n.mobile_content::-webkit-scrollbar-thumb {/*滚动条里面小方块*/\n    cursor: pointer;\n    border-radius: 5px;\n    background: #e9e9e9;\n    -webkit-transition: color .2s ease;\n    transition: color .2s ease;\n}\n\n.mobile_content::-webkit-scrollbar-thumb:hover {\n    background: #e3e3e3;\n}\n/* 自定义滚动条 */\n.content::-webkit-scrollbar {/*滚动条整体样式*/\n    -webkit-appearance: none;\n    width: 10px;\n    height: 10px;\n}\n\n.content::-webkit-scrollbar-thumb {/*滚动条里面小方块*/\n    cursor: pointer;\n    border-radius: 5px;\n    background: #e9e9e9;\n    -webkit-transition: color .2s ease;\n    transition: color .2s ease;\n}\n\n.content::-webkit-scrollbar-thumb:hover {\n    background: #e3e3e3;\n}\n\n.item_box {\n    width: 60%;\n    margin: 0 auto;\n    padding-right: 50px;\n    padding-bottom: 16px;\n}\n\n::selection {\n    background-color: #cce2ff;\n    color: rgba(0,0,0,.87);\n}\n\n.message_times {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    height: 27px;\n    padding-left: 63px;\n    margin-top: 32px;\n    font-size: 16px;\n}\n\n.message_times_text {\n    display: inline-block;\n    width: auto;\n    height: 100%;\n    padding: 0 5px;\n    border-radius: 6px;\n    color: #fff;\n    background-color: #cbd1d8;\n    line-height: 27px;\n}\n\n.message_times_today_text {\n    width: 100%;\n    height: 27px;\n    margin: 0 !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `MessageList_content__Wa2If`,
	"mobile_content": `MessageList_mobile_content__EZHn4`,
	"item_box": `MessageList_item_box__78XFY`,
	"message_times": `MessageList_message_times__9MbYy`,
	"message_times_text": `MessageList_message_times_text__x4xXD`,
	"message_times_today_text": `MessageList_message_times_today_text__jzLqK`
};
export default ___CSS_LOADER_EXPORT___;
